module.exports = __webpack_public_path__ + "static/media/crowdplance-header.6b2850b9.png";